import api from './api';

export async function getCompaniesAPI() {
  return api.get(`/api/backoffice/Companies`).then((response) => response.data);
}
